var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "weixin-collect-input",
      attrs: {
        "element-loading-text":
          "正在加载文章内容。如果文章图片较多，可能时间会较慢，请耐心等候。",
        "element-loading-background": "rgba(0, 0, 0, 0.8)"
      }
    },
    [
      _c("el-input", {
        staticClass: "collection-input",
        attrs: {
          placeholder: "输入微信公众号文章链接地址，可采集文章内容到下方编辑区"
        },
        model: {
          value: _vm.address,
          callback: function($$v) {
            _vm.address = $$v
          },
          expression: "address"
        }
      }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "collection-btn",
          attrs: { type: "primary", disabled: !_vm.collection_address },
          on: { click: _vm.collectHandler }
        },
        [_vm._v("采集")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61e8e952", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61e8e952","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/weixinCollectInput.vue
// module id = 1222
// module chunks = 7